export const CHOOSE_CARD = 'chooseCard';
export const REASON_OF_REQUESTING = 'reasonOfRequesting';
export const SENDING_ADDRESS = 'sendingAddress';
export const SUMMARY = 'summary';

export const SUMMARY_INFO = {
  DE_ACTIVE_VIRTUAL_CARD: {
    title: 'You’re about to deactivate your virtual card.',
    description:
      'When you confirm your new virtual card, this card will be deactivated, and any recurring charges on it will not be processed.',
    hasBoxContent: false
  },
  CARD_ON_THE_WAY: {
    title: 'Your new card will be sent to you soon.',
    description:
      'The replacement card will get there in 7 to 10 business days with the same card number and expiration date. You’ll need to reset the PIN.',
    hasBoxContent: true
  },
  REPLACE_CARD: {
    title: 'Your current card will be deactivated',
    description:
      'We’ll send your replacement card to this address. Since it’s a new card, you’ll need to activate it and set a new PIN.',
    hasBoxContent: true
  }
};

export const REASON = {
  LOST: 'Lost',
  STOLEN: 'Stolen',
  DAMAGED: 'Damaged'
};

export const REASON_PAYLOAD = {
  LOST: 'lost',
  STOLEN: 'stolen',
  REPLACE: 'replace'
};

export const NO_VALUE_CARD = {
  PHYSICAL_CARD: 'No value'
};
